import React from 'react'
import ModalForm from '../common/modal-form'
import DynamicColor from '../common/dynamic-color'
import { COLOR_NAME } from '../../constants'
import { useTranslation } from 'react-i18next'

const ModalClose = ({ isOpen, onClose, message, messageParams }) => {
    const { t } = useTranslation()

    return (
        <ModalForm
            isOpen={isOpen}
            centered
            rootClass="modal-overtime"
            contentClass="py-6 px-3"
        >
            <DynamicColor
                style={{ color: COLOR_NAME.MODAL_TEXT }}
                className="text-center"
            >
                <div className="message">{t('modalOverTime.messageTodayOff')}</div>
            </DynamicColor>
        </ModalForm>
    )
}

export default ModalClose
